import { EnumWithDescription, ICustomEnumValue } from "./EnumWithDescription";

export enum ServiceLocationsEnum {
    "Home - Q5001" = 1,
    "Assisted Living Facility - Q5002" = 2,
    "LTC or Non-Skilled NF (unskilled care) - Q5003" = 3,
    "Skilled Nursing Facility (skilled care) - Q5004" = 4,
    "Inpatient Hospital - Q5005" = 5,
    "Inpatient Hospice - Q5006" = 6,
    "Long Term Care Hospital - Q5007" = 7,
    "Inpatient Psychiatric Facility - Q5008" = 8,
    "Place not Otherwise Specified - Q5009" = 9,
    "Hospice Residential Facility - Q5010" = 10
}

export class ServiceLocationsEnumClass extends EnumWithDescription<ServiceLocationsEnum> {
    public readonly enum = ServiceLocationsEnum;
    public readonly enumName: string = "ServiceLocationsEnum";
    public readonly enumWithDescriptions: Map<string, ICustomEnumValue<ServiceLocationsEnum>> = new Map([
        [
            "Home - Q5001",
            {
                value: ServiceLocationsEnum["Home - Q5001"],
                name: "Home - Q5001e"
            }
        ],
        [
            "Assisted Living Facility - Q5002",
            {
                value: ServiceLocationsEnum["Assisted Living Facility - Q5002"],
                name: "Assisted Living Facility - Q5002"
            }
        ],
        [
            "LTC or Non-Skilled NF (unskilled care) - Q5003",
            {
                value: ServiceLocationsEnum["LTC or Non-Skilled NF (unskilled care) - Q5003"],
                name: "LTC or Non-Skilled NF (unskilled care) - Q5003"
            }
        ],
        [
            "Skilled Nursing Facility (skilled care) - Q5004",
            {
                value: ServiceLocationsEnum["Skilled Nursing Facility (skilled care) - Q5004"],
                name: "Skilled Nursing Facility (skilled care) - Q5004"
            }
        ],
        [
            "Inpatient Hospital - Q5005",
            {
                value: ServiceLocationsEnum["Inpatient Hospital - Q5005"],
                name: "Inpatient Hospital - Q5005"
            }
        ],
        [
            "Inpatient Hospice - Q5006",
            {
                value: ServiceLocationsEnum["Inpatient Hospice - Q5006"],
                name: "Inpatient Hospice - Q5006"
            }
        ],
        [
            "Long Term Care Hospital - Q5007",
            {
                value: ServiceLocationsEnum["Long Term Care Hospital - Q5007"],
                name: "Long Term Care Hospital - Q5007"
            }
        ],
        [
            "Inpatient Psychiatric Facility - Q5008",
            {
                value: ServiceLocationsEnum["Inpatient Psychiatric Facility - Q5008"],
                name: "Inpatient Psychiatric Facility - Q50086"
            }
        ],
        [
            "Place not Otherwise Specified - Q5009",
            {
                value: ServiceLocationsEnum["Place not Otherwise Specified - Q5009"],
                name: "Place not Otherwise Specified - Q5009"
            }
        ],
        [
            "Hospice Residential Facility - Q5010",
            {
                value: ServiceLocationsEnum["Hospice Residential Facility - Q5010"],
                name: "Hospice Residential Facility - Q5010"
            }
        ]
    ]);
}

export const ServiceLocations = new ServiceLocationsEnumClass();
